<div class="summary-detail-panel">
    <div class="summary-detail-table">
        <div
            class="summary-main-item"
            [ngClass]="{ isProjected: fmvProjected }"
            (click)="updateChartType(ActivityPanelModes.totalFMV)"
        >
            Total MV: <span class="data-value">{{ currentYear.totalMV | currency: 'USD' : '' }}</span>
        </div>
        @if (impsSqFt && impsSqFt.value > 0) {
            <div
                class="summary-sub-item"
                [ngClass]="{ isProjected: fmvProjected }"
                (click)="updateChartType(ActivityPanelModes.totalFMVPerSqFt)"
            >
                Total MV $/SqFt:
                <span class="data-value">{{ currentYear.totalMV / impsSqFt.value | currency: 'USD' : '' }}</span>
            </div>
        }
        @if (units && units.value > 0) {
            <div
                class="summary-sub-item"
                [ngClass]="{ isProjected: fmvProjected }"
                (click)="updateChartType(ActivityPanelModes.totalFMVPerUnit)"
            >
                Total MV $/Unit:
                <span class="data-value">{{ currentYear.totalMV / units.value | currency: 'USD' : '' }} </span>
            </div>
        }
        @if (acres && acres.value > 0 && acres.value < 10 && currentYear.fmvForLandTypeComponents.fmv > 0) {
            <div
                class="summary-sub-item land-fmv-per-sqft"
                [ngClass]="{ isProjected: fmvProjected }"
                (click)="updateChartType(ActivityPanelModes.landFMVPerSqFt)"
            >
                Land MV $/SqFt:
                <span class="data-value">{{
                    currentYear.fmvForLandTypeComponents.mv / acres.value / 43560 | currency: 'USD' : ''
                }}</span>
            </div>
        }
        @if (acres && acres.value > 0 && currentYear.fmvForLandTypeComponents.fmv > 0) {
            <div
                class="summary-sub-item land-fmv-per-acre"
                [ngClass]="{ isProjected: fmvProjected }"
                (click)="updateChartType(ActivityPanelModes.landFMVPerAcre)"
            >
                Land MV $/Acre:
                <span class="data-value">{{
                    currentYear.fmvForLandTypeComponents.mv / acres.value | currency: 'USD' : ''
                }}</span>
            </div>
        }
    </div>

    <div
        class="summary-total-tax"
        [ngClass]="{ isProjected: taxProjected }"
        (click)="updateChartType(ActivityPanelModes.totalTaxes)"
    >
        Total Tax: <span class="data-value">{{ totalTaxes | currency }}</span>
    </div>

    <div class="summary-appeal-section" (click)="updateChartType(ActivityPanelModes.recentAppeals)">
        <div class="appeal-info">
            Appeal: <span class="appeal-value">{{ appealStatus }}</span>
        </div>
        @if (currentYear.taxSavings && currentYear.taxSavings.savings > 0) {
            <div class="appeal-savings"> Savings: {{ currentYear.taxSavings.savings | currency: '' }} </div>
        }
        @if (recentSavings.length > 0 && !(currentYear.taxSavings && currentYear.taxSavings.savings > 0)) {
            <div class="recent-appeals">
                <a>Recent Savings</a>
            </div>
        }
    </div>
</div>
